import { useCallback } from 'react';
import { handleOnChange } from '../utils/handleOnChange';
export var useOnToggleAll = function useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange, setInitialSelection) {
  return useCallback(function () {
    var selectAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var preselectedDisabledOptionItems = [];
    var unselectedDisabledOptionItems = [];
    internalOptions.forEach(function (option) {
      if (option.disabled) {
        if (!internalValue.includes(option.value)) {
          unselectedDisabledOptionItems.push(option.value);
        } else {
          preselectedDisabledOptionItems.push(option.value);
        }
      }
    });

    if (!selectAll) {
      handleOnChange([], onChange);

      if (setInitialSelection) {
        setInitialSelection([].concat(preselectedDisabledOptionItems));
      }

      if (setInternalValue) {
        setInternalValue([].concat(preselectedDisabledOptionItems));
      }

      return;
    }

    if (internalValue.length + unselectedDisabledOptionItems.length === internalOptions.length) {
      var updatedOptionValues = [].concat(preselectedDisabledOptionItems, unselectedDisabledOptionItems);

      if (internalValue.length < internalOptions.length) {
        updatedOptionValues = [].concat(preselectedDisabledOptionItems);
      }

      handleOnChange(updatedOptionValues, onChange);

      if (setInternalValue) {
        setInternalValue(updatedOptionValues);
      }

      return;
    }

    var enabledOptionValuesOnSelect = [];
    internalOptions.forEach(function (option) {
      if (!option.disabled || option.disabled && internalValue.includes(option.value)) {
        enabledOptionValuesOnSelect.push(option.value);
      }
    });
    handleOnChange(enabledOptionValuesOnSelect, onChange);

    if (setInternalValue) {
      setInternalValue(enabledOptionValuesOnSelect);
    }
  }, [setInternalValue, internalOptions, internalValue]);
};